/**
 * MinecraftSkin — renders a live 3D-ish skin body view + optional cape.
 * Uses mc-heads.net (free, no API key, CORS-safe) for renders.
 * Modes:
 *  - "body"   : full body left-facing
 *  - "front"  : front body
 *  - "head"   : just avatar / face
 *  - "isometric": isometric render
 * Falls back gracefully if the username isn't set.
 */
export default function MinecraftSkin({ username, mode = "body", size = 200, cape = false, className = "" }) {
  if (!username) {
    return (
      <div className={`grid place-items-center rounded-xl border border-white/10 bg-black/40 text-white/30 text-xs ${className}`} style={{ width: size, height: size }}>
        No skin linked
      </div>
    );
  }
  const capeParam = cape ? "?overlay" : "";
  const url = {
    body: `https://mc-heads.net/body/${username}/left${capeParam}`,
    front: `https://mc-heads.net/body/${username}${capeParam}`,
    head: `https://mc-heads.net/avatar/${username}/${Math.max(64, size)}`,
    isometric: `https://mc-heads.net/head/${username}/${Math.max(128, size)}`,
  }[mode] || `https://mc-heads.net/body/${username}/left`;

  return (
    <div
      className={`relative flex items-center justify-center ${className}`}
      style={{ width: size, height: size * 1.4 }}
      data-testid="minecraft-skin"
    >
      <div
        className="absolute inset-0 rounded-xl"
        style={{
          background: "radial-gradient(circle at 50% 60%, rgba(255,191,0,0.16), transparent 60%)",
          filter: "blur(24px)",
        }}
      />
      <img
        src={url}
        alt={`${username} skin`}
        className="relative z-10 h-full w-auto object-contain drop-shadow-[0_0_18px_rgba(255,191,0,0.25)]"
        loading="lazy"
        onError={(e) => (e.currentTarget.style.display = "none")}
      />
    </div>
  );
}
